import { Image, Body1, Caption } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './SuggestItem.css';
import historyIconSrc from './assets/clock.svg';
import { ISuggestion } from '../../types/suggestions';

interface ISuggestItemProps {
  suggest: ISuggestion;
}

export const SuggestItem: React.FC<ISuggestItemProps> = ({ suggest }) => {
  return (
    <div className={styles['item']}>
      <div className={styles['icon-block']}>
        {suggest.icon ? (
          <Image
            src={suggest.icon}
            width={24}
            height={24}
            preloader={false}
            borderRadius="0"
            data-name="suggest_image"
          />
        ) : (
          <Image
            src={historyIconSrc}
            width={24}
            height={24}
            preloader={false}
            borderRadius="0"
            data-name="suggest_image"
          />
        )}
      </div>
      <div className={styles['text-block']}>
        <div className={styles['label']}>
          <Body1>{suggest.query}</Body1>
        </div>
        <Caption color="text-secondary-default">{suggest.geo}</Caption>
      </div>
    </div>
  );
};
